import React from 'react';

export default function HoleInput({ holeNumber, hole, onChange, errors = {} }) {
  const handleChange = (field, value) => {
    const parsedValue = value === '' ? null : parseInt(value);

    onChange(holeNumber - 1, {
      holeNumber: hole.holeNumber,
      par: hole.par,
      strokeIndex: hole.strokeIndex,
      yardage: hole.yardage || null,
      [field]: parsedValue
    });
  };

  return (
    <div className="bg-white border border-gray-200 p-3 flex items-center gap-3">
      <div className="flex-shrink-0 w-16">
        <span className="text-sm font-semibold text-gray-900">Hole {holeNumber}</span>
      </div>

      <div className="flex-1 grid grid-cols-2 gap-3">
        {/* Par */}
        <div>
          <select
            value={hole.par || ''}
            onChange={(e) => handleChange('par', e.target.value)}
            className={`w-full px-2 py-1 text-sm border rounded ${
              errors.par ? 'border-red-600 bg-red-100' : 'border-gray-300 bg-white'
            }`}
            required
          >
            <option value="">Par</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
          </select>
          {errors.par && (
            <p className="mt-0.5 text-xs text-red-700">{errors.par}</p>
          )}
        </div>

        {/* Stroke Index */}
        <div>
          <input
            type="number"
            min="1"
            max="18"
            value={hole.strokeIndex || ''}
            onChange={(e) => handleChange('strokeIndex', e.target.value)}
            className={`w-full px-2 py-1 text-sm border rounded ${
              errors.strokeIndex ? 'border-red-600 bg-red-100' : 'border-gray-300 bg-white'
            }`}
            placeholder="SI (1-18)"
            required
          />
          {errors.strokeIndex && (
            <p className="mt-0.5 text-xs text-red-700">{errors.strokeIndex}</p>
          )}
        </div>
      </div>
    </div>
  );
}
